import React from "react";
import { StyleSheet, Text, View } from "@react-pdf/renderer";

const Th = ({
  isLeft,
  text,
  fontSize,
  trWidth,
  withWeight,
  children,
  fontArray,
}) => {
  const styles = StyleSheet.create({
    th: {
      display: "flex",
      fontSize: fontSize,
      width: `${trWidth * withWeight}%`,
      border: "1px solid black",
      borderLeft: isLeft ? "1px solid black" : "none",
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
      padding: "5px 3px",
      backgroundColor: "rgb(215, 214, 214)",
    },
    font: {
      fontFamily: "NotoSansTC",
    },
  });
  return (
    <View style={[styles.th]}>
      {children ? children : <Text style={[styles.font]}>{text}</Text>}
    </View>
  );
};

export default Th;
